export default [
  // 应用
  {
    path: "/application",
    name: "application",
    component: () => import("@/CommonDP/pages/mainMg/application"),
    meta: {
      routeName: "应用",
      icon: require("@/CommonDP/assets/settings/application.svg")
    },
    children: [
      {
        path: "/applicationAll",
        name: "applicationAll",
        component: () => import("@/CommonDP/pages/mainMg/application/applicationAll"),
        meta: {
          routeName: "全部应用",
          prouteName: "全部应用",
          pname: "应用"
        }
      },
      {
        // 企业看板
        path: "/enterpriseBoard",
        name: "enterpriseBoard",
        component: () => import("@/CommonDP/pages/mainMg/application/enterpriseBoard/enterpriseBoard.vue"),
        meta: {
          routeName: "数据看板",
          prouteName: "数据看板",
          pname: "应用",
          icon: require("@/CommonDP/assets/approval/epBoard.png")
        }
      },
      {
        path: "/createProject",
        name: "createProject",
        component: () => import("@/CommonDP/pages/mainMg/application/createProject/list.vue"),
        meta: {
          routeName: "立项管理",
          prouteName: "立项管理",
          pname: "应用",
          icon: require("@/CommonDP/assets/approval/project.png")
        },
        children: []
      },
      {
        path: "/createProjectList",
        component: () => import("@/CommonDP/pages/mainMg/application/createProject/list.vue"),
        name: "createProjectList",
        meta: {
          routeName: "立项管理",
          prouteName: "立项管理",
          ppname: "应用"
        }
      },
      {
        path: "/createProjectAddEdit",
        name: "createProjectAddEdit",
        component: () => import("@/CommonDP/pages/mainMg/application/createProject/createProjectAddEdit.vue"),
        meta: {
          routeName: "",
          prouteName: "",
          ppname: "应用"
        }
      },
      {
        path: "/standard",
        name: "standard",
        component: () => import("@/CommonDP/pages/mainMg/application/standard/index.vue"),
        meta: {
          routeName: "标准管理",
          prouteName: "标准管理",
          pname: "应用",
          icon: require("@/CommonDP/assets/approval/standard.png")
        },
        children: [
          {
            path: "/standardTemplate",
            name: "standardTemplate",
            component: () => import("@/CommonDP/pages/mainMg/application/standard/standardTemplate/index.vue"),
            meta: {
              routeName: "标准模板维护",
              prouteName: "标准模板维护",
              ppname: "应用",
              icon: require("@/CommonDP/assets/standard/template.png")
            }
          },
          {
            path: "/standardDrawingFrame",
            name: "standardDrawingFrame",
            component: () => import("@/CommonDP/pages/mainMg/application/standard/standardDrawingFrame/index.vue"),
            meta: {
              routeName: "标准图框维护",
              prouteName: "标准图框维护",
              ppname: "应用",
              icon: require("@/CommonDP/assets/standard/frame.png")
            }
          },
          {
            path: "/standardFont",
            name: "standardFont",
            component: () => import("@/CommonDP/pages/mainMg/application/standard/standardFont/index.vue"),
            meta: {
              routeName: "字体样式维护",
              prouteName: "字体样式维护",
              ppname: "应用",
              icon: require("@/CommonDP/assets/standard/font.png")
            }
          },
          {
            path: "/standardCadFont",
            name: "standardCadFont",
            component: () => import("@/CommonDP/pages/mainMg/application/standard/standardCadFont/index.vue"),
            meta: {
              routeName: "CAD字体维护",
              prouteName: "CAD字体维护",
              ppname: "应用",
              icon: require("@/CommonDP/assets/standard/cadFont.png")
            }
          },
          {
            path: "/linearStyle",
            name: "linearStyle",
            component: () => import("@/CommonDP/pages/mainMg/application/standard/linearStyle/index.vue"),
            meta: {
              routeName: "线型样式维护",
              prouteName: "线型样式维护",
              ppname: "应用",
              icon: require("@/CommonDP/assets/standard/linear.png")
            }
          },
          {
            path: "/provideInformationFrame",
            name: "provideInformationFrame",
            component: () => import("@/CommonDP/pages/mainMg/application/standard/provideInformationFrame/index.vue"),
            meta: {
              routeName: "提资框维护",
              prouteName: "提资框维护",
              ppname: "应用"
            }
          },
          {
            path: "/revitMaintenance",
            name: "revitMaintenance",
            component: () => import("@/CommonDP/pages/mainMg/application/standard/revitMaintenance/index.vue"),
            meta: {
              routeName: "revit样板维护",
              prouteName: "revit样板维护",
              ppname: "应用",
              icon: require("@/CommonDP/assets/standard/template.png")
            }
          },
          {
            path: "/standardLayer",
            name: "standardLayer",
            component: () => import("@/CommonDP/pages/mainMg/application/standard/standardLayer/index.vue"),
            meta: {
              routeName: "标准图层维护",
              prouteName: "标准图层维护",
              ppname: "应用",
              icon: require("@/CommonDP/assets/standard/layer.png")
            }
          },
          {
            path: "/templateDirectory",
            name: "templateDirectory",
            component: () => import("@/CommonDP/pages/mainMg/application/standard/templateDirectory/index.vue"),
            meta: {
              routeName: "目录模板维护",
              prouteName: "目录模板维护",
              ppname: "应用",
              icon: require("@/CommonDP/assets/standard/directory.png")
            }
          },
          {
            path: "/collaborationLayer",
            name: "collaborationLayer",
            component: () => import("@/CommonDP/pages/mainMg/application/standard/collaborationLayer/index.vue"),
            meta: {
              routeName: "协作图层维护",
              prouteName: "协作图层维护",
              ppname: "应用",
              icon: require("@/CommonDP/assets/standard/layer.png")
            }
          },
          {
            path: "/provideInformationLayer",
            name: "provideInformationLayer",
            component: () => import("@/CommonDP/pages/mainMg/application/standard/provideInformationLayer/index.vue"),
            meta: {
              routeName: "提资图层维护",
              prouteName: "提资图层维护",
              ppname: "应用",
              icon: require("@/CommonDP/assets/standard/layer.png")
            }
          },
          {
            path: "/stamp",
            name: "stamp",
            component: () => import("@/CommonDP/pages/mainMg/application/standard/stamp/index.vue"),
            meta: {
              routeName: "电子图章维护",
              prouteName: "电子图章维护",
              ppname: "应用",
              icon: require("@/CommonDP/assets/standard/stamp.png")
            }
          },
          {
            path: "/signature",
            name: "signature",
            component: () => import("@/CommonDP/pages/mainMg/application/standard/signature/index.vue"),
            meta: {
              routeName: "电子签名维护",
              prouteName: "电子签名维护",
              ppname: "应用",
              icon: require("@/CommonDP/assets/standard/signature.png")
            }
          },
          {
            path: "/frameField",
            name: "frameField",
            component: () => import("@/CommonDP/pages/mainMg/application/standard/frameField/index.vue"),
            meta: {
              routeName: "图框字段",
              prouteName: "图框字段",
              ppname: "应用",
              icon: require("@/CommonDP/assets/standard/frame.png")
            }
          },
          {
            path: "/printConfiguration",
            name: "printConfiguration",
            component: () => import("@/CommonDP/pages/mainMg/application/standard/printConfiguration/index.vue"),
            meta: {
              routeName: "打印配置",
              prouteName: "打印配置",
              ppname: "应用",
              icon: require("@/CommonDP/assets/standard/print.png")
            },
            children: [
              {
                path: "/configurationFile",
                name: "configurationFile",
                component: () => import("@/CommonDP/pages/mainMg/application/standard/configurationFile/index.vue"),
                meta: {
                  routeName: "绘图仪配置文件",
                  prouteName: "绘图仪配置文件",
                  pppname: "应用",
                  icon: require("@/CommonDP/assets/standard/configurationFile.png")
                }
              },
              {
                path: "/parameterFile",
                name: "parameterFile",
                component: () => import("@/CommonDP/pages/mainMg/application/standard/parameterFile/index.vue"),
                meta: {
                  routeName: "绘图仪型号参数文件",
                  prouteName: "绘图仪型号参数文件",
                  pppname: "应用",
                  icon: require("@/CommonDP/assets/standard/parameterFile.png")
                }
              },
              {
                path: "/styleSheet",
                name: "styleSheet",
                component: () => import("@/CommonDP/pages/mainMg/application/standard/styleSheet/index.vue"),
                meta: {
                  routeName: "打印样式表",
                  prouteName: "打印样式表",
                  pppname: "应用",
                  icon: require("@/CommonDP/assets/standard/styleSheet.png")
                }
              }
            ]
          },
          {
            path: "/planApprovalPoints",
            name: "planApprovalPoints",
            component: () => import("@/CommonDP/pages/mainMg/application/standard/planApprovalPoints/index.vue"),
            meta: {
              routeName: "审图要点",
              prouteName: "审图要点",
              ppname: "应用",
              icon: require("@/CommonDP/assets/standard/planApprovalPoints.png")
            }
          },
          {
            path: "/revitSet",
            name: "revitSet",
            component: () => import("@/CommonDP/pages/mainMg/application/standard/revitSet/index.vue"),
            meta: {
              routeName: "Revit导出设置",
              prouteName: "Revit导出设置",
              ppname: "应用",
              icon: require("@/CommonDP/assets/standard/revitSet.png")
            },
            children: [
              {
                path: "/ruleSet",
                name: "ruleSet",
                component: () => import("@/CommonDP/pages/mainMg/application/standard/revitSet/ruleSet.vue"),
                meta: {
                  routeName: "规则设置",
                  prouteName: "规则设置",
                  pppname: "应用",
                  icon: require("@/CommonDP/assets/standard/ruleSet.png")
                }
              },
              {
                path: "/fontStyleSet",
                name: "fontStyleSet",
                component: () => import("@/CommonDP/pages/mainMg/application/standard/revitSet/fontStyleSet.vue"),
                meta: {
                  routeName: "字体样式设置",
                  prouteName: "字体样式设置",
                  pppname: "应用",
                  icon: require("@/CommonDP/assets/standard/fontStyleSet.png")
                }
              }
            ]
          },
          {
            path: "/layerDetachFile",
            name: "layerDetachFile",
            component: () => import("@/CommonDP/pages/mainMg/application/standard/layerDetachFile/index.vue"),
            meta: {
              routeName: "图层拆离文件",
              prouteName: "图层拆离文件",
              ppname: "应用",
              icon: require("@/CommonDP/assets/standard/layerDetachFile.png")
            }
          },
          {
            path: "/workSpace",
            name: "workSpace",
            component: () => import("@/CommonDP/pages/mainMg/application/standard/workSpace/index.vue"),
            meta: {
              routeName: "工作空间管理",
              prouteName: "工作空间管理",
              ppname: "应用",
              icon: require("@/CommonDP/assets/standard/workSpace.png")
            }
          },
          {
            path: "/printRules",
            name: "printRules",
            component: () => import("@/CommonDP/pages/mainMg/application/standard/printRules/index.vue"),
            meta: {
              routeName: "打印命名规则",
              prouteName: "打印命名规则",
              ppname: "应用",
              icon: require("@/CommonDP/assets/standard/printRules.png")
            }
          }
        ]
      },
      {
        path: "/hoursReport",
        component: () => import("@/CommonDP/pages/mainMg/application/workTime/hoursReport/index"),
        name: "hoursReport",
        meta: {
          title: "工时填报",
          routeName: "工时填报",
          prouteName: "工时填报",
          pname: "应用"
        }
      },
      {
        path: "/statisticalAnalysis",
        component: () => import("@/CommonDP/pages/mainMg/application/workTime/statisticalAnalysis/index"),
        name: "statisticalAnalysis",
        meta: {
          title: "工时看板",
          routeName: "工时看板",
          prouteName: "工时看板",
          pname: "应用"
        }
      },
      // {
      //   path: "/workTime",
      //   name: "workTime",
      //   component: () =>
      //     import("@/CommonDP/pages/mainMg/application/workTime/index.vue"),
      //   meta: {
      //     routeName: "工时管理",
      //     prouteName: "工时管理",
      //     pname: "应用"
      //   },
      //   children: [
      //     {
      //       path: "/hoursReport",
      //       component: () =>
      //         import(
      //           "@/CommonDP/pages/mainMg/application/workTime/hoursReport/index"
      //         ),
      //       name: "hoursReport",
      //       meta: {
      //         title: "工时填报",
      //         routeName: "工时填报",
      //         prouteName: "工时填报",
      //         pname: "应用"
      //       }
      //     },
      //     {
      //       path: "/statisticalAnalysis",
      //       component: () =>
      //         import(
      //           "@/CommonDP/pages/mainMg/application/workTime/statisticalAnalysis/index"
      //         ),
      //       name: "statisticalAnalysis",
      //       meta: {
      //         title: "工时看板",
      //         routeName: "工时看板",
      //         prouteName: "工时看板",
      //         pname: "应用"
      //       }
      //     }
      //     //   path: '/createProjectAddEdit',
      //     //   component: () =>
      //     //     import(
      //     //       '@/CommonDP/pages/mainMg/application/createProject/createProjectAddEdit.vue'
      //     //     ),
      //     //   name: 'createProjectAddEdit',
      //     //   meta: {
      //     //     routeName: '',
      //     //     prouteName: '',
      //     //     ppname: '应用',
      //     //   },
      //     // },
      //   ]
      // },
      {
        // 族库管理
        path: "/familyLibrary",
        name: "familyLibrary",
        component: () => import("@/CommonDP/pages/mainMg/application/familyLibrary/familyLibrary.vue"),
        meta: {
          routeName: "族库管理",
          prouteName: "族库管理",
          pname: "应用",
          icon: require("@/CommonDP/assets/approval/familyLibrary.png")
        }
      },
      {
        // ISO管理
        path: "/isoManagement",
        name: "isoManagement",
        component: () => import("@/CommonDP/pages/mainMg/application/isoManagement/isoManagement.vue"),
        meta: {
          routeName: "ISO管理",
          prouteName: "ISO管理",
          pname: "应用",
          icon: require("@/CommonDP/assets/approval/isoManagement.png")
        }
      },
      // 视图管理
      {
        path: "/viewManagement",
        name: "viewManagement",
        component: () => import("@/CommonDP/pages/mainMg/application/viewManagement/viewManagement.vue"),
        meta: {
          routeName: "视图管理",
          prouteName: "视图管理",
          pname: "应用",
          icon: require("@/CommonDP/assets/approval/viewManagement.png")
        }
      }
    ]
  }
];
